import styled from 'styled-components';

export const StyledBaiduMapView = styled.div`
  height: 100%;
  width: 100%;
  .g-map-container {
    height: 100%;
    width: 100%;
  }
`;
